export default function Footer() {
  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-950 pt-14 pb-0">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 pb-12">
          <div className="flex-1 max-w-xs">
            <img src="https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/11/logo-1.svg" alt="Nanit" className="h-9 mb-4 brightness-0 invert" />
            <p className="text-sm text-gray-500 leading-relaxed mb-2">We are always open to cooperation and value feedback from our customers.</p>
            <p className="text-xs text-gray-600">Made in Ukraine. Faraday Robotics Company</p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { href: 'https://www.instagram.com/nanit_robot/', icon: 'ri-instagram-line' },
                { href: 'https://www.facebook.com/nanitrobot', icon: 'ri-facebook-line' },
                { href: 'https://www.youtube.com/@nanitrobot', icon: 'ri-youtube-line' },
                { href: 'https://www.linkedin.com/company/nanitrobohouse/', icon: 'ri-linkedin-line' },
              ].map((s) => (
                <a key={s.href} href={s.href} rel="nofollow" target="_blank"
                  className="w-9 h-9 flex items-center justify-center bg-gray-800 rounded-full text-gray-400 hover:bg-yellow-400 hover:text-gray-900 transition-all duration-200 cursor-pointer">
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-10 flex-1">
            <div>
              <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">Navigation</p>
              <div className="flex flex-col gap-2">
                {[
                  { label: 'About', id: 'about' },
                  { label: 'Why Inclusive', id: 'why' },
                  { label: 'How It Works', id: 'how' },
                  { label: 'Robot', id: 'robot' },
                  { label: 'Offers', id: 'offers' },
                  { label: 'Reviews', id: 'reviews' },
                  { label: 'Contact', id: 'contact' },
                ].map((l) => (
                  <a key={l.id} href={`#${l.id}`} onClick={(e) => handleAnchor(e, l.id)}
                    className="text-sm text-gray-500 hover:text-yellow-400 transition-colors cursor-pointer">
                    {l.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">External Links</p>
              <div className="flex flex-col gap-2">
                {[
                  { label: 'For Preschool', href: 'https://kids.nanitrobot.com/en/for_preschool/' },
                  { label: 'For School', href: 'https://kids.nanitrobot.com/en/for-school/' },
                  { label: 'About Us', href: 'https://kids.nanitrobot.com/en/about-us/' },
                  { label: 'Shop', href: 'https://kids.nanitrobot.com/en/shop/' },
                  { label: 'Blog', href: 'https://kids.nanitrobot.com/en/blog/' },
                  { label: 'Cooperation', href: 'https://kids.nanitrobot.com/en/cooperation/' },
                ].map((l) => (
                  <a key={l.href} href={l.href} rel="nofollow"
                    className="text-sm text-gray-500 hover:text-yellow-400 transition-colors">
                    {l.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">Support</p>
              <div className="flex flex-col gap-3">
                <a href="tel:+380974340309" className="text-sm font-semibold text-gray-300 hover:text-yellow-400 transition-colors">+38097 434 0309</a>
                <a href="tel:+380635960309" className="text-sm font-semibold text-gray-300 hover:text-yellow-400 transition-colors">+38063 596 0309</a>
                <a href="https://t.me/Arsen_robohouse" className="text-sm text-gray-500 hover:text-yellow-400 transition-colors flex items-center gap-2">
                  <i className="ri-telegram-line"></i> Telegram
                </a>
                <a href="viber://chat?number=+380635960309" className="text-sm text-gray-500 hover:text-yellow-400 transition-colors flex items-center gap-2">
                  <i className="ri-phone-line"></i> Viber
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-xs text-gray-600">Copyright 2022–2026 © Nanit Robotics Lab. All rights reserved</span>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-gray-600 hover:text-gray-400">Offer contract</a>
            <a href="/en/delivery/" className="text-xs text-gray-600 hover:text-gray-400">Delivery &amp; Payment</a>
            <a href="/en/privacy-policy/" className="text-xs text-gray-600 hover:text-gray-400">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
